export const menu = [
	{
		id: 0,
		text: 'ACT',
		to: '/act'
	},
	{
		id: 1,
		text: 'TECH',
		to: '/tech-stack'
	},
	{
		id: 2,
		text: 'TEAM',
		to: '/team'
	},
	{
		id: 3,
		text: 'OPEN',
		to: '/open-source'
	},
	{
		id: 4,
		text: 'AI',
		to: '/ai'
	}
]
